module.exports = __webpack_public_path__ + "img/ar.9148c883.png";